module.exports = __webpack_public_path__ + "img/send-tx-page.4b941247.jpg";